import { InjectionToken } from '@angular/core';

import { IErrorData } from './client-models/coordinator.models';

export const eventConstants = {
    EVENT_GEOLOCATION_ERROR: 'GEOLocation.ERROR',
    GEOLOCATION_ERRORCODE: 'geolocation.errorCode' as const,
    GEOLOCATION_ERRORMESSAGE: 'geolocation.errorMessage' as const,
    EVENT_TRIGGER_GEO_FETCH: '' as const,
    GEOLOCATION_FETCH_TYPE: '' as const,
};

export enum RetryTypes {
    NonRetry = 0,
    Retry = 1,
}

export enum ErrorTypes {
    Error = 'ERROR',
    Info = 'INFO',
    Success = 'SUCCESS',
}

export enum GeoComplyKeys {
    GeoComplyRegionCode = 'geoComplyRegionCode',
    GeoComplyUuid = 'geoComplyUUID',
    GeoComplySdkSolution = 'geoComplySdkSolution',
    GeoComplyRegion = 'geoComplyRegion',
    GeoComplyOs = 'geoComplyOS',
}

export const ErrorDataToken = new InjectionToken<IErrorData>('Geoguard:errorData');
export const ErrorMessagesToken = new InjectionToken<import('./client-models/location-info').GDSTroubleshooterMessage[]>('Geoguard:errorMessages');
